import React from 'react';
import { useAppSelector } from '../../../Redux/Store/hooks';
import { ItemTypeConstants } from '../../../Resources/ItemTypeConstants';
import { CatalogObjectDisplayObject } from '../../Data/CatalogObjectDisplayObject';
import { StaticTableComponent } from '../Components/Specific/StaticTableComponent';

type SearchViewParameters = {
  searchQuery : string | undefined,
  results : CatalogObjectDisplayObject[],
  navigateToObjectPageHandler : (
    collectionName: string,
    objectName: string,
    pageType: string) => void,
};

export function SearchView({
  searchQuery,
  results,
  navigateToObjectPageHandler,
} : SearchViewParameters) {

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  return (
    <StaticTableComponent
      title={`${results.length} ${strings.RESULTS_FOR} "${searchQuery}"`}
      itemsList={results}
      itemsType={ItemTypeConstants.DYNAMIC_ITEMS}
      displayNewPage={navigateToObjectPageHandler}
      noContentText={strings.NO_CONTENT_TEXT}
    />
  );
}
